export const GET_RECOMMENDATIONS_QUERY_KEY = "get-recommendations";
